export default __webpack_public_path__ + "static/media/NT-Edusys-logo.f105b8f1.jpg";